import type { ScheduledCourse } from '@/app/types/course';

/** Restore explicit choices without turning unconfigured members into closed-section overrides. */
export function restoreCourseListEligibility(
  sections: readonly ScheduledCourse[],
  previous: Record<string, string[]> | undefined,
  completed: Set<string>,
): Record<string, string[]> {
  const currentSections = new Map<string, Set<string>>();
  for (const section of sections) {
    const indexes = currentSections.get(section.baseId) ?? new Set<string>();
    indexes.add(section.id);
    currentSections.set(section.baseId, indexes);
  }

  const restored = new Map<string, string[]>();
  for (const [courseId, indexes] of Object.entries(previous ?? {})) {
    const current = currentSections.get(courseId);
    // An explicit choice with no surviving current-term section stays excluded.
    // Removing its key would silently broaden it back to every section.
    restored.set(courseId, completed.has(courseId)
      ? []
      : [...new Set(indexes)].filter(index => current?.has(index)));
  }
  for (const courseId of currentSections.keys()) {
    if (completed.has(courseId)) restored.set(courseId, []);
  }
  return Object.fromEntries(restored);
}
